import React from 'react';
import {
    Container,
    PolicyName,
    SubTopicText,
    TopicText,
    StyledDivider,
    ScoreTitle,
    Score
} from './LabelDetails.style';

const LabelDetails = ({ policyName, riskColor = '#5b8bff', topic, subtopic, score }) => {
    return (
        <Container riskColor={riskColor}>
            <PolicyName riskColor={riskColor}>{policyName}</PolicyName>
            {topic && <TopicText>{topic}</TopicText>}
            {subtopic && <SubTopicText>{subtopic}</SubTopicText>}

            {score > -1 && (
                <>
                    <StyledDivider />
                    <ScoreTitle>
                        <Score>Score : </Score> {parseFloat(score).toFixed(2)}
                    </ScoreTitle>
                </>
            )}
        </Container>
    );
};

export { LabelDetails };
